import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SensorStateService {

  isSensorConnected: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() { }
}
